<template>
  <input
    ref="slider"
    type="range"
    class="pe-slider"
    :class="baseClasses"
    :min="min"
    :max="max"
    :disabled="disabled"
    :value="modelValue"
    @input="onUpdate"
  />
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue'

export default defineComponent({
  props: {
    modelValue: Number,
    type: {
      type: String,
      default: 'primary'
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    disabled: Boolean
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const slider = ref(null)
    const percent = ref('50%')

    const baseClasses = computed(() => {
      const obj = {}

      if (props.type && ['primary', 'danger', 'success', 'purple'].includes(props.type)) {
        obj[props.type] = true
      }

      if (!props.disabled) obj['cursor-pointer'] = true

      return obj
    })

    const updatePercent = () => {
      percent.value = `${(100 * slider.value.value) / (props.max - props.min)}%`
    }

    const onUpdate = () => {
      updatePercent()
      emit('update:modelValue', Number(slider.value.value) )
    }

    onMounted(() => {
      updatePercent()
    })

    return {
      slider,
      percent,
      baseClasses,
      onUpdate
    }
  }
})
</script>

<style lang="scss" scoped>
.pe-slider {
  @apply h-1 appearance-none rounded outline-none;

  &::-webkit-slider-thumb {
    @apply block h-3 w-3 appearance-none rounded-full;
  }
  &.primary {
    background: linear-gradient(
      90deg,
      rgba(38, 38, 38, 1) 0%,
      rgba(38, 38, 38, 1) v-bind(percent),
      rgba(38, 38, 38, 0.25) v-bind(percent),
      rgba(38, 38, 38, 0.25) 100%
    );

    &::-webkit-slider-thumb {
      @apply bg-neutral-800;
    }
  }

  &.success {
    background: linear-gradient(
      90deg,
      rgba(74, 222, 128, 1) 0%,
      rgba(74, 222, 128, 1) v-bind(percent),
      rgba(74, 222, 128, 0.25) v-bind(percent),
      rgba(74, 222, 128, 0.25) 100%
    );

    &::-webkit-slider-thumb {
      @apply bg-green-400;
    }
  }

  &.danger {
    background: linear-gradient(
      90deg,
      rgba(239, 68, 68, 1) 0%,
      rgba(239, 68, 68, 1) v-bind(percent),
      rgba(239, 68, 68, 0.25) v-bind(percent),
      rgba(239, 68, 68, 0.25) 100%
    );

    &::-webkit-slider-thumb {
      @apply bg-red-500;
    }
  }

  &.purple {
    background: linear-gradient(
      90deg,
      rgba(168, 85, 247, 1) 0%,
      rgba(168, 85, 247, 1) v-bind(percent),
      rgba(168, 85, 247, 0.25) v-bind(percent),
      rgba(168, 85, 247, 0.25) 100%
    );

    &::-webkit-slider-thumb {
      @apply bg-purple-500;
    }
  }
}
</style>
